import { onUnmounted } from 'vue'

/**
 * 要素と交差（特定の位置にスクロール）したときに実行   
 * @param {{
 * target: HTMLElement|HTMLElement[],
 * onEnter: Function,
 * onLeave?: Function,
 * root: null,
 * threshold: 0,
 * rootMargin:'0px',
 * }}
 * 以下の引数をオブジェクトに格納
 * @param target      監視する要素（複数の要素を監視する場合は配列を使用）
 * @param onEnter     コールバック関数（監視する要素が対象の要素に入った時に実行）
 * @param onLeave     コールバック関数（監視する要素が対象の要素から出た時に実行）
 * @param root        IntersectionObserverのrootオプション
 * @param threshold   IntersectionObserverのthresholdオプション
 * @param rootMargin  IntersectionObserverのrootMarginオプション
 * @see https://developer.mozilla.org/ja/docs/Web/API/Intersection_Observer_API
 */

export default function useIntersectionObserver({ target, onEnter, onLeave, root, threshold, rootMargin }){
  
  if (typeof IntersectionObserver === 'undefined') return

  // IntersectionObserverのコールバック関数
  const callback = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        if(!onEnter) return
        onEnter(entry)
      }
      if (!entry.isIntersecting) {
        if(!onLeave) return
        onLeave(entry)
      }
    })
  }

  // IntersectionObserverのオプション
  const options = {
    root: root,
    threshold: threshold,
    rootMargin: rootMargin,
  }

  const observer = new IntersectionObserver(callback, options)

  // 監視する要素が配列（複数）の場合
  if(Array.isArray(target)){
    target.forEach((target) => {
      observer.observe(target)
    })
  }
  // 監視する要素が配列ではない場合
  if(!Array.isArray(target)){
    observer.observe(target)
  }

  onUnmounted(() => {
    observer.disconnect()
  })

}